import React, { useState, useEffect } from 'react'
import './type.less'
import { setHeader } from '@/util/set-header'
import { fetchType } from '@/api/repair'
import { Toast } from 'antd-mobile'

function Type({ history }: any) {
  const [types, setTypes] = useState([])
  useEffect(() => {
    const leftClick = () => {
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
    }
    setHeader({
      title: '报修类型',
      right: <span onClick={() => history.push('/repair/list')}>报修工单</span>,
      leftClick,
    })
    const fetchData = async () => {
      Toast.loading('加载中', 0)
      const { data } = await fetchType()
      Toast.hide()
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 1.5)
        return false
      }
      setTypes(data.data)
    }
    fetchData()
  }, [history])

  const submitTicket = (child: any) => {
    history.push({
      pathname: '/repair/submit',
      state: child,
    })
  }
  return (
    <div className="type-content font-6">
      {types.map((type: any) => (
        <div className="primary-type" key={type.id}>
          <span className="title">{type.name}</span>
          <div className="secondary-type">
            {type?.child?.map((child: any) => (
              <span
                onClick={() => submitTicket(child)}
                className="title"
                key={child.id}
              >
                {child.name}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default Type
